import apiService from './api-service';

const Registrations = {};
const urlEntity = "/registrations";

Registrations.all = (q = null, limit = null, page = null) => {
    if (q) {
        q.limit = limit;
        q.page = page;
    } else {
        q = {};
        q.limit = limit;
        q.page = page;
    }
    return apiService.get(urlEntity, {
        params: q,
    })
        .then((res) => res)
};

Registrations.allWithGrades = (q = null, limit = null, page = null) => {
    if (q) {
        q.limit = limit;
        q.page = page;
    } else {
        q = {};
        q.limit = limit;
        q.page = page;
    }
    return apiService.get(`${urlEntity}/index-with-grades`, {
        params: q,
    })
        .then((res) => res)
};

Registrations.allDebts = (q = null, limit = null, page = null) => {
    if (q) {
        q.limit = limit;
        q.page = page;
    } else {
        q = {};
        q.limit = limit;
        q.page = page;
    }
    return apiService.get(`${urlEntity}/index-debts`, {
        params: q,
    })
        .then((res) => res)
};

Registrations.getOne = (id) => {
    return apiService.get(`${urlEntity}/${id}`)
        .then((res) => res)
};

Registrations.showView = (id) => {
    return apiService.get(`${urlEntity}/show-view/${id}`)
        .then((res) => res)
};

Registrations.getAll = () => {
    return apiService.get(`${urlEntity}/all`)
        .then((res) => res)
};

Registrations.add = (data) => {
    return apiService.post(urlEntity, data)
        .then((res) => res)
};

Registrations.edit = (id, data) => {
    return apiService.put(`${urlEntity}/${id}`, data)
        .then((res) => res)
};

Registrations.refound = (id, data) => {
    return apiService.put(`${urlEntity}/refound/${id}`, data)
        .then((res) => res)
};

Registrations.notRefound = (id, data) => {
    return apiService.put(`${urlEntity}/not-refound/${id}`, data)
        .then((res) => res)
};

Registrations.delete = (id) => {
    return apiService.delete(`${urlEntity}/${id}`)
        .then((res) => res)
};

Registrations.lastCourse = (student_id = null) => {
    var q = {};
    if (student_id) {
        q.student_id = student_id;
    }
    return apiService.get(`${urlEntity}/last-course`, {
        params: q,
    }).then((res) => res);
};

Registrations.selectAllCoursesByStudent = (courses_offered_year = null, period = null, student_person_id) => {
    var q = {};
    if (courses_offered_year) {
        q.courses_offered_year = courses_offered_year;
    }
    if (period) {
        q.period = period;
    }
    if (student_person_id) {
        q.student_person_id = student_person_id;
    }
    return apiService.get(`${urlEntity}/select-all-courses-by-students`, {
        params: q,
    })
        .then((res) => res);
};

Registrations.getRegistrationSyllabusTuition = async (student_id = null) => {
    var q = {};
    if (student_id) {
        q.student_id = student_id;
    }
    return apiService.get(`${urlEntity}/get-registration-syllabus-tuition`, {
        params: q,
    })
        .then((res) => res);
};

export default Registrations;
